// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles__modal___2FygQ","overlay":"styles__overlay___2mghs"};